<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g><path data-follow-fill="currentColor" d="M765 931c-89 0-161.4-72.4-161.4-161.4S676 608.2 765 608.2s161.4 72.4 161.4 161.4c-.1 89-72.5 161.4-161.4 161.4zm0-239.6c-43.2 0-78.3 35.1-78.3 78.3 0 43.2 35.1 78.3 78.3 78.3 43.2 0 78.3-35.1 78.3-78.3-.1-43.2-35.2-78.3-78.3-78.3zM168.8 880.1c-11.1 0-21.5-4.3-29.4-12.2-15.9-15.9-16.2-42.1-.5-58.3l677.8-677.8c7.8-7.8 18.3-12.2 29.4-12.2 11.1 0 21.5 4.3 29.4 12.2l1.2 1.2c7.1 7.7 11 17.7 11 28.2 0 11.1-4.3 21.5-12.2 29.4l-678 677.9c-7.7 7.5-17.9 11.6-28.7 11.6zm68.9-476.3c-89 0-161.4-72.4-161.4-161.4S148.7 81 237.7 81s161.4 72.4 161.4 161.4-72.4 161.4-161.4 161.4zm0-239.7c-43.2 0-78.3 35.1-78.3 78.3 0 43.2 35.1 78.3 78.3 78.3 43.2 0 78.3-35.1 78.3-78.3 0-43.2-35.1-78.3-78.3-78.3z" :fill="_fill" /></g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
